import React from 'react';
import { observer } from 'src/utils/mobx-react';

type TableHeaderProps = {
    eventName: string;
    marketName: string;
    isMultiplesWidget: boolean;
};

export const TableHeader = observer(
    'LiabilitiesTableHeader',
    ({
        eventName,
        marketName,
        isMultiplesWidget
    }: TableHeaderProps): JSX.Element => {
        const type = isMultiplesWidget ? 'Multiples' : 'Singles';

        return <h4 data-test='liabilities-header'>{`${eventName} / ${marketName} / ${type}`}</h4>;
    }
);
